module.exports = __webpack_public_path__ + "static/media/5-Night-mobile.30a4a4a5.webp";